import { FundsDistributionContext } from 'core/cuenta/contexts/FundsDistributionContext';
import { useCoreService } from 'core/services/useCoreService';
import { useContext, useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Card } from 'shared/components';
import { PBody } from 'shared/components/Fonts';
import { FormValue } from 'shared/form';
import { Select } from 'shared/form/components/Select';
import { SelectOption } from 'shared/form/models/SelectOption';
import { useDataFetcher } from 'shared/http';
import { InputPlaceholder, TextPlaceholder } from 'shared/placeholders';
import { formatCurrency } from 'shared/utils';

const getMontoTotalTransferencia = (values: object) => {
  if (!values) return 0;
  return Object.values(values).reduce((total, amount) => total + (amount || 0), 0);
};

export const FundsDistributionOrigin = () => {
  const { setCuentaOrigen, origen, isLoading } = useContext(FundsDistributionContext);
  const [visibleAccounts, setRequest] = useDataFetcher<SelectOption<number>[]>();
  const coreService = useCoreService();

  useEffect(() => {
    setRequest(async () => {
      const cuentas = await coreService.getVisibleAccounts({
        visibilidad: 'TRANSFERENCIA',
        cuentasHuerfanas: false,
      });
      return cuentas.map((account) => ({
        label: account.label,
        value: account.numeroCuenta,
      }));
    });
  }, [coreService, setRequest]);

  return (
    <Card>
      <Card.Title>Cuenta Origen</Card.Title>
      <Card.Body className="p-3">
        <Row className="pb-3">
          <Col>
            {visibleAccounts.isLoading || isLoading ? (
              <InputPlaceholder />
            ) : (
              <Select
                label="Cuenta Origen"
                name="origen"
                placeholder="Selecciona una cuenta"
                value={
                  origen
                    ? {
                        label: origen.label,
                        value: origen.numeroCuenta,
                      }
                    : null
                }
                options={visibleAccounts.data}
                onChange={(event) => setCuentaOrigen(event.value)}
              />
            )}
          </Col>
        </Row>
        {!isLoading ? (
          <Row>
            <Col>
              <PBody>
                <span className="fw-bold">Número Cuenta: </span>
                {origen?.numeroCuenta}
              </PBody>
              {origen?.tipoCuenta === 'CENTRO_COSTO' ? (
                <PBody>
                  <span className="fw-bold">Denominacion: </span>
                  {origen?.nombreCentroCosto}
                </PBody>
              ) : (
                <>
                  {origen?.tarjetas.map((tarjeta) => (
                    <PBody key={tarjeta.numero}>
                      <span className="fw-bold">Denominacion: </span>
                      {tarjeta.denominacion} - {tarjeta.numero}
                    </PBody>
                  ))}
                </>
              )}
            </Col>
            <Col>
              <PBody>
                <span className="fw-bold">Saldo inicial: </span>
                {formatCurrency(origen?.saldoDisponible)}
              </PBody>
              <PBody>
                <span className="fw-bold">Saldo a transferir: </span>
                <FormValue
                  render={({ value }) => (
                    <span>{formatCurrency(getMontoTotalTransferencia(value))}</span>
                  )}
                />
              </PBody>
              <FormValue
                render={({ value }) => {
                  const saldoFinal =
                    origen?.saldoDisponible - getMontoTotalTransferencia(value);
                  return (
                    <PBody
                      data-testid="saldofinal"
                      $color={saldoFinal < 0 ? 'danger' : 'neutralStrong'}
                    >
                      <span className="fw-bold">Saldo final: </span>
                      <span>{formatCurrency(saldoFinal)}</span>
                    </PBody>
                  );
                }}
              />
            </Col>
          </Row>
        ) : (
          <Row>
            <Col>
              <TextPlaceholder height={22} />
              <TextPlaceholder height={22} />
              <TextPlaceholder height={22} />
            </Col>
            <Col>
              <TextPlaceholder height={22} />
              <TextPlaceholder height={22} />
              <TextPlaceholder height={22} />
            </Col>
          </Row>
        )}
      </Card.Body>
    </Card>
  );
};
